module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Regular.4b0ff42e.woff";